import {Action} from '@ngrx/store';

export const GET_ALL_BRANDS = '[Brands] Get All';
export const GET_ALL_BRANDS_SUCCESS = '[Brands] Get All Success';
export const GET_ALL_BRANDS_ERROR = '[Brands] Get All Error';

export const GET_BRAND = '[Brands] Get Brand';
export const GET_BRAND_SUCCESS = '[Brands] Get Brand Success';
export const GET_BRAND_ERROR = '[Brands] Get Brand Error';

export const ADD_BRAND = '[Brand] Add';
export const ADD_BRAND_SUCCESS = '[Brand] Add Success';
export const ADD_BRAND_ERROR = '[Brand] Add Error';

export const UPDATE_BRAND = '[Brand] Update';
export const UPDATE_BRAND_SUCCESS = '[Brand] Update Success';
export const UPDATE_BRAND_ERROR = '[Brand] Update Error';

export const GET_BRAND_MANAGERS = '[Brand] Get Brand Managers';
export const GET_BRAND_MANAGERS_SUCCESS = '[Brands] Get Brand Managers Success';
export const GET_BRAND_MANAGERS_ERROR = '[Brands] Get Brand Managers Error';


export class GetAllBrands implements Action {
  readonly type = GET_ALL_BRANDS;
}

export class GetAllBrandsSuccess implements Action {
  readonly type = GET_ALL_BRANDS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllBrandsError implements Action {
  readonly type = GET_ALL_BRANDS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetBrand implements Action {
  readonly type = GET_BRAND;

  constructor(public payload: any) {
  }
}

export class GetBrandSuccess implements Action {
  readonly type = GET_BRAND_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetBrandError implements Action {
  readonly type = GET_BRAND_ERROR;

  constructor(public payload: any) {
  }
}

export class AddBrand implements Action {
  readonly type = ADD_BRAND;

  constructor(public payload: any) {
  }
}

export class AddBrandSuccess implements Action {
  readonly type = ADD_BRAND_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddBrandError implements Action {
  readonly type = ADD_BRAND_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateBrand implements Action {
  readonly type = UPDATE_BRAND;

  constructor(public payload: any) {
  }
}

export class UpdateBrandSuccess implements Action {
  readonly type = UPDATE_BRAND_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateBrandError implements Action {
  readonly type = UPDATE_BRAND_ERROR;

  constructor(public payload: any) {
  }
}


export class GetBrandManagers implements Action {
  readonly type = GET_BRAND_MANAGERS;
}

export class GetBrandManagersSuccess implements Action {
  readonly type = GET_BRAND_MANAGERS_SUCCESS;

  constructor(public payload: any) {
  }
}


export class GetBrandManagersError implements Action {
  readonly type = GET_BRAND_MANAGERS_ERROR;

  constructor(public payload: any) {
  }
}


export type BrandAction =
  GetAllBrands
  | GetAllBrandsSuccess
  | GetAllBrandsError
  | GetBrand
  | GetBrandError
  | GetBrandSuccess
  | AddBrand
  | AddBrandSuccess
  | AddBrandError
  | UpdateBrand
  | UpdateBrandSuccess
  | UpdateBrandError
  | GetBrandManagers
  | GetBrandManagersSuccess
  | GetBrandManagersError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/store/actions/brand.action.ts